import Vue from 'vue';
import Vuex from 'vuex';
import db from '@/utils/localstorage';
import { api_login, api_getUserInfo, api_getEnterpriseList } from '@/api/user';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 登录状态
    isLoggedIn: false,
    // 用户信息
    userInfo: db.get('userInfo', {}),
    // 登录token
    token: db.get('ACCESS_TOKEN', ''),
    // 企业列表
    enterprises: db.get('enterprises', []),
    // 当前选中的企业
    currentEnterprise: db.get('currentEnterprise', {})
  },
  mutations: {
    // 设置登录状态
    setIsLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    // 设置用户信息
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      // 将用户信息存储到localStorage
      db.save('userInfo', userInfo);
    },
    // 设置token
    setToken(state, token) {
      state.token = token;
      // 将token存储到localStorage
      if (token) {
        db.save('ACCESS_TOKEN', token);
      } else {
        db.remove('ACCESS_TOKEN');
      }
    },
    // 登出
    logout(state) {
      state.isLoggedIn = false;
      state.userInfo = {
        phone: '',
        username: '',
        avatar: ''
      };
      state.token = '';
      state.enterprises = [];
      state.currentEnterprise = {};
      db.remove('ACCESS_TOKEN');
      db.remove('userInfo');
      db.remove('enterprises');
      db.remove('currentEnterprise');
    },
    // 设置企业列表
    setEnterprises(state, enterprises) {
      state.enterprises = enterprises;
      // 将企业列表存储到localStorage
      db.save('enterprises', enterprises);
    },
    // 设置当前选中的企业
    setCurrentEnterprise(state, enterprise) {
      state.currentEnterprise = enterprise;
      // 将当前选中的企业存储到localStorage
      db.save('currentEnterprise', enterprise);
    }
  },
  actions: {
    // 登录
    async login({ commit }, loginData) {
      try {
        // 模拟登录，实际项目中调用API
        const response = await api_login(loginData);
        console.log('登录成功:', response);
        // 保存token
        commit('setToken', response.data.tokenId);
        // 保存用户信息
        // commit('setUserInfo', response.data.userInfo);
        // 设置登录状态
        commit('setIsLoggedIn', true);
        return Promise.resolve(response);
      } catch (error) {
        console.error('登录失败:', error);
        return Promise.reject(error);
      }
    },
    // 登出
    logout({ commit }) {
      commit('logout');
    },
    // 获取用户信息
    async getUserInfo({ commit, state }) {
      try {
        // 模拟获取用户信息，实际项目中调用API
        const response = await api_getUserInfo();
        commit('setUserInfo', response.data);
        commit('setIsLoggedIn', true);
        return Promise.resolve(response);
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 如果获取用户信息失败，可能是token过期，需要登出
        commit('logout');
        return Promise.reject(error);
      }
    },
    // 刷新企业列表
    async refreshEnterpriseList({ commit, state }) {
      try {
        // 模拟获取企业列表，实际项目中调用API
        const response = await api_getEnterpriseList();
        const enterprises = response.data || [];
        commit('setEnterprises', enterprises);
        const index = enterprises.findIndex(
          (item) => item.id === state.currentEnterprise.id
        );
        if (index !== -1) {
          commit('setCurrentEnterprise', enterprises[index]);
        } else {
          // 默认选中第一个企业
          if (enterprises.length > 0) {
            commit('setCurrentEnterprise', enterprises[0]);
          }
        }
        return Promise.resolve(response);
      } catch (error) {
        console.error('刷新企业列表失败:', error);
        return Promise.reject(error);
      }
    },
    // 获取企业列表
    async getEnterpriseList({ commit, state }) {
      try {
        // 模拟获取企业列表，实际项目中调用API
        const response = await api_getEnterpriseList();
        const enterprises = response.data || [];
        commit('setEnterprises', enterprises);
        // 默认选中第一个企业
        if (enterprises.length > 0) {
          commit('setCurrentEnterprise', enterprises[0]);
        }
        return Promise.resolve(response);
      } catch (error) {
        console.error('获取企业列表失败:', error);
        return Promise.reject(error);
      }
    },
    // 切换企业
    switchEnterprise({ commit }, enterprise) {
      commit('setCurrentEnterprise', enterprise);
      // 触发企业切换事件，让所有需要重新获取数据的组件响应
      import('@/utils/eventBus').then(({ default: eventBus }) => {
        eventBus.$emit('enterpriseChanged', enterprise);
      });
    }
  },
  getters: {
    // 获取登录状态
    isLoggedIn: (state) => state.isLoggedIn,
    // 获取用户信息
    userInfo: (state) => state.userInfo,
    // 获取token
    token: (state) => state.token,
    // 获取企业列表
    enterprises: (state) => state.enterprises,
    // 获取当前选中的企业
    currentEnterprise: (state) => state.currentEnterprise
  }
});
